import all from "../assets/images/bags/All.svg";
import benelux from "../assets/images/bags/Benelux.svg";
import fr from "../assets/images/bags/France.svg";
import ger from "../assets/images/bags/Germany.svg";
import scandinavia from "../assets/images/bags/Scandinavia.svg";
import sa from "../assets/images/bags/SouthAfrica.svg";
import es from "../assets/images/bags/Spain.svg";
import sw from "../assets/images/bags/Switzerland.svg";
import uae from "../assets/images/bags/UAE.svg";
import uganda from "../assets/images/bags/Uganda.svg";
import uk from "../assets/images/bags/UnitedKingdom.svg";

export const BAGS: any = {
  benelux,
  fr,
  ger,
  scandinavia,
  sa,
  es,
  sw,
  uae,
  uganda,
  uk,
  all
};
